import { EmployeeController } from '../../controllers';
import { MimaToastUtil } from '../../components';
import { SpecificEmployee } from '../../pages';
import { employeeStore, userStore } from '../../stores';
import constant from '../../utils/constant';
import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { object, string } from 'yup';
import { useGetAllActiveReviews } from '../../controllers/SurveyController';

const SpecificEmployeeContainer = ({ closeModal, setShowSurvey }) => {
	const [personalInfo, setPersonalInfo] = useState(false);
	const [jobInfo, setJobInfo] = useState(false);
	const [bankDetails, setBankDetails] = useState(false);
	const [deductions, setDeductions] = useState(false);
	const [loans, setLoans] = useState(false);
	const [editState, setEditState] = useState(false);
	const [terminate, setTerminate] = useState(false);
	const [terminate2, setTerminate2] = useState(false);
	const [suspension, setSuspension] = useState(false);
	const [terminateStatus, setTerminateStatus] = useState('');
	const [success, setSuccess] = useState(false);
	const [loading, setLoading] = useState(false);
	const [stage2, setStage2] = useState(false);
	const [stage3, setStage3] = useState(false);
	const [makeAdmin, setMakeAdmin] = useState(false);

	const { needFeedback } = useGetAllActiveReviews(
		constant.FEEDBACK.EMPLOYEETERMINATE
	);

	const showStage2 = () => {
		setStage2(true);
		setStage3(false);
	};

	const showStage3 = () => {
		setStage2(false);
		setStage3(true);
	};

	const showEditSuccess = () => {
		setStage3(false);
		setSuccess(true);
	};

	const showStage1 = () => {
		setStage2(false);
		setStage3(false);
		setSuccess(false);
	};

	const showPersonalInfo = () => {
		setPersonalInfo(!personalInfo);
		setJobInfo(false);
		setBankDetails(false);
		setDeductions(false);
		setLoans(false);
	};

	const showJobInfo = () => {
		setPersonalInfo(false);
		setJobInfo(!jobInfo);
		setBankDetails(false);
		setDeductions(false);
		setLoans(false);
	};

	const showBankDetails = () => {
		setPersonalInfo(false);
		setJobInfo(false);
		setBankDetails(!bankDetails);
		setDeductions(false);
		setLoans(false);
	};

	const showDeductions = () => {
		setPersonalInfo(false);
		setJobInfo(false);
		setBankDetails(false);
		setDeductions(!deductions);
		setLoans(false);
	};

	const showLoans = () => {
		setPersonalInfo(false);
		setJobInfo(false);
		setBankDetails(false);
		setDeductions(false);
		setLoans(!loans);
	};

	const goBack = () => {
		if (editState && stage2) {
			showStage1();
		} else if (editState && stage3) {
			showStage2();
		} else if (editState) {
			setEditState(false);
		} else if (terminate2) {
			setTerminate2(false);
			setTerminate('Terminate');
		} else if (terminate === 'Terminate' || terminate === 'Suspend') {
			setTerminate('');
		} else if (suspension) {
			setSuspension(false);
			setTerminate('Suspend');
		} else if (makeAdmin) {
			setMakeAdmin(false);
		} else {
			closeModal();
		}
	};

	const suspensionSchema = () => {
		return object({
			suspensionStartDate: string().required(
				'Suspension start date is required'
			),
			suspensionEndDate: string().required('Suspension end date is required'),
			reason: string().required('Reason is required'),
		});
	};
	const terminationSchema = () => {
		return object({
			terminationDate: string().required('Termination date is required'),
			reason: string().required('Reason is required'),
		});
	};

	const onSubmit = async payload => {
		setLoading(true);
		payload.status =
			terminateStatus === 'Terminate' ? 'TERMINATED' : 'SUSPENDED';
		if (payload.otherReason) {
			payload.reason = payload.otherReason;
		}
		delete payload.otherReason;
		const { status, errorMessage } = await EmployeeController.deleteEmployee(
			payload,
			employeeStore.selectedEmployee._id
		);
		if (status === constant.Success) {
			setLoading(false);
			MimaToastUtil.success({
				message: constant.Success,
			});
			closeModal();
			if (needFeedback._id) {
				setShowSurvey(true);
				userStore.setReviewId(needFeedback._id);
			}
			return;
		}
		setLoading(false);
		return MimaToastUtil.error({
			message: errorMessage,
		});
	};

	const unSuspend = async () => {
		setLoading(true);
		const { status, errorMessage } = await EmployeeController.unSuspendEmployee(
			employeeStore.selectedEmployee._id
		);
		if (status === constant.Success) {
			setLoading(false);
			MimaToastUtil.success({
				message: constant.Success,
			});
			return closeModal();
		}
		setLoading(false);
		return MimaToastUtil.error({
			message: errorMessage,
		});
	};

	const employeeDeductions = [];
	Object?.entries(employeeStore.selectedEmployee.deductions).forEach(
		([key, value]) =>
			employeeDeductions.push(
				`${key.toLocaleUpperCase()}:  ${value ? 'Yes' : 'No'}`
			)
	);
	const goToEditState = () => {
		setEditState(true);
	};

	const showTerminate = value => {
		setTerminateStatus(value);
		setTerminate(true);
	};

	const showTerminate2 = () => {
		setTerminate2(true);
		setSuspension(false);
		setTerminate(false);
	};
	const showSuspension = () => {
		setSuspension(true);
		setTerminate2(false);
		setTerminate(false);
	};
	const next = () => {
		if (employeeStore.selectedEmployee.status === 'SUSPENDED') {
			unSuspend();
		} else if (terminateStatus === 'Terminate') {
			showTerminate2();
		} else {
			showSuspension();
		}
	};

	const showSuccess = () => {
		setTerminate2(false);
		setSuccess(true);
	};

	const showEmployeeAdmin = () => {
		userStore.setSelectedAdmin(employeeStore.selectedEmployee);
		setMakeAdmin(true);
	};

	return (
		<SpecificEmployee
			closeModal={closeModal}
			validationTerminationSchema={terminationSchema}
			employee={employeeStore.selectedEmployee}
			showPersonalInfo={showPersonalInfo}
			showJobInfo={showJobInfo}
			terminationSchema={terminationSchema}
			validationSuspensionSchema={suspensionSchema}
			showBankDetails={showBankDetails}
			onSubmit={onSubmit}
			personalInfo={personalInfo}
			terminateStatus={terminateStatus}
			jobInfo={jobInfo}
			loading={loading}
			employeeDeductions={employeeDeductions}
			deductions={deductions}
			showDeductions={showDeductions}
			bankDetails={bankDetails}
			editState={editState}
			goToEditState={goToEditState}
			terminate={terminate}
			next={next}
			suspension={suspension}
			showTerminate={showTerminate}
			terminate2={terminate2}
			showTerminate2={showTerminate2}
			success={success}
			showSuccess={showSuccess}
			stage2={stage2}
			stage3={stage3}
			showStage2={showStage2}
			showStage3={showStage3}
			showEditSuccess={showEditSuccess}
			showStage1={showStage1}
			goBack={goBack}
			showLoans={showLoans}
			loans={loans}
			showEmployeeAdmin={showEmployeeAdmin}
			makeAdmin={makeAdmin}
		/>
	);
};

export default observer(SpecificEmployeeContainer);
